// AddPricingModal.js
import React, { useContext, useEffect } from "react";
import { ApiContext } from "../../../../context/MyContext";
import PricingListForm from "../PricingListForm/PricingListForm";

const AddPricingModal = ({ planId, planName, onClose, onSuccess }) => {
  const { post } = useContext(ApiContext);

  // Handle Escape key to close modal
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onClose]);

  return (
    <div 
      className="fixed inset-0 z-40 flex items-center justify-center bg-black/20"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div 
        className="bg-white rounded-xl shadow-lg p-6 min-w-[400px] relative max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          className="absolute top-2 right-3 text-2xl font-bold text-gray-500 hover:text-gray-700 transition-colors" 
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
        <PricingListForm
          planId={planId}
          planName={planName}
          post={post}
          onSuccess={onSuccess}
          onClose={onClose}
          submitLabel="Add Pricing"
          headerText="Add New Pricing Option"
        />
      </div>
    </div>
  );
};

export default AddPricingModal;
